var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vf-lbl"},[(_vm.required)?_c('label',{staticClass:"vf-lbl-required"},[_vm._v("*")]):_vm._e(),_c('label',{class:[
        {'vf-lbl-d' : _vm.desc},
        {'vf-lbl-i' : _vm.input},
        {'vf-lbl-e' : _vm.error},
        {'vf-lbl-disabled' : _vm.disabled} ]},[_vm._v(_vm._s(_vm.text))]),(_vm.tooltip)?_c('div',{staticClass:"vf-lbl-tooltip",attrs:{"data-tooltip":_vm.tooltip}},[_c('div',{staticClass:"vf-lbl-tooltip-icon"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }